module.exports = __webpack_public_path__ + "static/images/going_box_title_cancle.ae76197.png";